/* Coastal Villa — cv-custom.js
   Carousel, product card ATC, collection filter auto-submit
   Header interactions live in cv-header.liquid inline <script>
*/
(function () {
  'use strict';

  /* ---------- Featured-collection carousel ---------- */
  document.querySelectorAll('[data-cv-carousel]').forEach(function (wrap) {
    var track   = wrap.querySelector('[data-cv-carousel-track]');
    var prevBtn = wrap.querySelector('[data-cv-carousel-prev]');
    var nextBtn = wrap.querySelector('[data-cv-carousel-next]');
    if (!track) return;

    function slideWidth() {
      var slide = track.querySelector('.cv-carousel__slide');
      return slide ? slide.offsetWidth + 16 : 300;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
    });
    function updateBtns() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    track.addEventListener('scroll', updateBtns, { passive: true });
    updateBtns();
  });

  /* ---------- Swatch hover/click → image swap ---------- */
  /* Delegated handler now lives in cv-quick-add.liquid inline script */

  /* ---------- PDP accordion ---------- */
  document.querySelectorAll('[data-cv-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var targetId = trigger.getAttribute('data-cv-accordion-target');
      var content  = targetId ? document.getElementById(targetId) : null;
      var isOpen   = trigger.getAttribute('aria-expanded') === 'true';

      var group = trigger.closest('[data-cv-accordion-group]');
      if (group) {
        group.querySelectorAll('[data-cv-accordion-trigger]').forEach(function (sib) {
          if (sib === trigger) return;
          sib.setAttribute('aria-expanded', 'false');
          var sibContent = document.getElementById(sib.getAttribute('data-cv-accordion-target'));
          if (sibContent) sibContent.classList.remove('is-open');
        });
      }
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (content) content.classList.toggle('is-open', !isOpen);
    });
  });

})();

/* ── Clear cart (drawer) — two-tap confirm, then clear + re-render in place.
   Delegated on document so it survives the drawer being re-rendered on
   add-to-cart (innerHTML swaps don't re-run inline scripts). ── */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cv-cart-clear');
    if (!btn) return;
    e.preventDefault();

    // First tap arms the button; it disarms itself if not confirmed.
    if (!btn.classList.contains('is-armed')) {
      btn.classList.add('is-armed');
      btn.dataset.label = btn.textContent;
      btn.textContent = 'Tap to confirm';
      btn.cvTimer = setTimeout(function () {
        btn.classList.remove('is-armed');
        btn.textContent = btn.dataset.label;
      }, 3500);
      return;
    }

    clearTimeout(btn.cvTimer);
    btn.disabled = true;
    btn.textContent = 'Clearing…';

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () { return fetch('/?sections=cart-drawer,cart-icon-bubble'); })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        if (sections['cart-drawer']) {
          var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var freshInner = doc.getElementById('CartDrawer');
          var curInner = document.getElementById('CartDrawer');
          if (freshInner && curInner) curInner.innerHTML = freshInner.innerHTML;
          var freshWrap = doc.querySelector('cart-drawer');
          var curWrap = document.querySelector('cart-drawer');
          if (freshWrap && curWrap) curWrap.classList.toggle('is-empty', freshWrap.classList.contains('is-empty'));
        }
        if (sections['cart-icon-bubble']) {
          var bubbleTarget = document.getElementById('cart-icon-bubble');
          var bDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var bInner = bDoc.querySelector('.shopify-section');
          if (bubbleTarget && bInner) bubbleTarget.innerHTML = bInner.innerHTML;
        }
      })
      .catch(function () { window.location.reload(); });
  });
})();
